<template>
    <div class="tile-content">
        <div class="grid-fitted dashboard-stats">
            <div class="grid-item text-left">
                <div class="stat stat-l text-left">
                    <div class="stat-title">{{metricSegment.name}}</div>
                    <div class="stat-value stat-value-link" v-fs-block>{{metricSegment.humanValue}}</div>
                </div>
            </div>
            <div class="grid-item text-right">
                <div class="stat stat-l text-right">
                    <div class="stat-title">{{relativeTime}}</div>
                    <div class="stat-value" :class="relativeColor(metricSegment)" v-fs-block>
                        <v-icon :icon="relativeIcon(metricSegment)"/>
                        {{metricSegment.humanChangeRatio}}
                    </div>
                </div>
            </div>
        </div>
        <metrics-sparkline :color="sparklineColor" ref="sparkline" :data="mapData(metricSegment.timeseries)"/>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';
    import MetricsSparkline from './metrics-sparkline';
    import DashboardBus from './dashboard-bus';

    export default {
        name: 'metrics-tile',
        components: {vIcon, MetricsSparkline},
        props: {
            segment: {
                type: Object,
                default: () => ({}),
            },
            metric: {
                type: Object,
                default: () => ({}),
            },
            relativeTime: {
                type: String,
                default: null,
            },
            inverse: {
                type: Boolean,
                default: false,
            },
            index: {
                type: Number,
            },
        },
        computed: {
            metricSegment() {
                return this.metric.segments
                    .find(metricSegment => metricSegment.name === this.segment.name);
            },
            sparklineColor() {
                const colors = ['217,227,249', '178,239,237', '213,215,220'];
                return colors[this.index];
            },
        },
        methods: {
            relativeColor({changeRatio}) {
                const value = changeRatio * (this.inverse ? -1 : 1);
                let type = 'is-positive';
                if (value === 0) {
                    type = 'is-neutral';
                } else if (value < 0) {
                    type = 'is-negative';
                }
                return {[type]: true};
            },
            relativeIcon({changeRatio}) {
                const value = changeRatio === null ? 0 : changeRatio;
                if (value === 0) {
                    return 'dash-l';
                }
                return value > 0 ? 'arrow-up-l' : 'arrow-down-l';
            },
            mapData(timeSeries) {
                return timeSeries.map(node => node.value);
            },
            validateReflow(segmentId) {
                if (this.segment.id === segmentId && this.$refs.sparkline) {
                    this.$refs.sparkline.$emit('reflow');
                }
            },
        },
        created() {
            DashboardBus.$on('reflow-sparkline', this.validateReflow);
        },
        beforeDestroy() {
            DashboardBus.$off('reflow-sparkline');
        },
    };
</script>
